module.exports = "# Mission Report\nTitle: Know Your Reservoirs\n\n# Questions\n\n## Content\n\n1. Number of Apprentices and Teachers reporting in.\n2. Number of teams that named at least one reservoir.\n3. Total number of Apprentices whose teams answered #2 correctly.\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoaHybrid/sections/12_missionReport/level1_reservoirs.md
// module id = 1725
// module chunks = 2